import { fetchJson, type Fetch } from "./http";
import { limiterFor } from "./ratelimit";

export interface Place {
  name: string;
  lat: number;
  lon: number;
}

const URL_BASE = "https://nominatim.openstreetmap.org/search";

/** Nominatim search. Call only on explicit submit (usage policy: no autocomplete). */
export async function geocode(q: string, f: Fetch = fetch): Promise<Place[]> {
  const query = q.trim();
  if (!query) return [];
  await limiterFor("nominatim.openstreetmap.org", 1100).wait();
  const url = `${URL_BASE}?${new URLSearchParams({ q: query, format: "jsonv2", limit: "5" })}`;
  const rows = await fetchJson<{ display_name: string; lat: string; lon: string }[]>(
    f,
    url,
    { headers: { accept: "application/json" } },
    15_000,
  );
  return rows.map((r) => ({ name: r.display_name, lat: Number(r.lat), lon: Number(r.lon) }));
}
